<template>
  <div>
    <card>
      <div slot="header" class="clearfix">
        <b>{{ $t("app.modules.users.headers.form") }}</b>
      </div>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(verifySave)">
          <div class="row">
            <div class="col-sm-12">

              <div class="form-group has-label">
                <label class="col-form-label">{{ $t('app.modules.users.headers.name') }}</label>

                <ValidationProvider
                  :name="$t('app.modules.users.headers.name')"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <fg-input
                    type="text"
                    :error="failed ? $t('app.general.required') : null"
                    :hasSuccess="passed"
                    :placeholder="$t('app.modules.users.headers.name')"
                    v-model="user.nombre"
                  >
                  </fg-input>
                </ValidationProvider>

              </div>

              <div class="form-group has-label">
                <label class="col-form-label">{{ $t('app.modules.users.headers.mail') }}</label>

                <ValidationProvider
                  :name="$t('app.modules.users.headers.mail')"
                  rules="required|email"
                  v-slot="{ passed, failed }"
                >
                  <fg-input
                    :disabled="idContacto !== 0"
                    type="email"
                    :error="failed ? $t('app.general.required') : null"
                    :hasSuccess="passed"
                    :placeholder="$t('app.modules.users.headers.mail')"
                    v-model="user.correo"
                  >
                  </fg-input>
                </ValidationProvider>

              </div>

              <div class="form-group has-label">
                <label class="col-form-label">{{ $t('app.modules.users.headers.phone') }}</label>

                <fg-input
                  type="phone"
                  :placeholder="$t('app.modules.users.headers.phone')"
                  v-model="telefono"
                >
                </fg-input>

              </div>

              <div class="form-group has-label">
                <label>{{ $t("app.modules.users.headers.role") }}</label>
                <el-select
                  size="large"
                  filterable
                  :placeholder="$t('app.modules.users.headers.select_role')"
                  v-model="user.roles_idRol"
                >
                  <el-option
                    v-for="rol in roles"
                    :value="rol.idRol"
                    :label="rol.nombre"
                    :key="rol.idRol"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="form-group has-label" style="margin-top: 20px">
                <div class="row">
                  <div class="col-6">
                    <label style="margin-right: 10px">{{ $t("app.modules.users.headers.status") }}: </label>
                    <template>
                      <n-switch v-model="user.activo">
                        <i class="now-ui-icons ui-1_check" slot="on"></i>
                        <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                      </n-switch>
                    </template>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div
            slot="footer"
            style="margin-top: 10px; padding-top: 20px;border-top: outset;"
            class="text-right"
          >
            <n-button class="pull-left" @click.native="cancel">{{
                $t("app.buttons.delete")
              }}</n-button>

            <verify-permission
              controller="Usuarios"
              action="addUser"
            >
              <n-button native-type="submit" type="primary">{{
                  $t("app.buttons.save")
                }}</n-button>
            </verify-permission>
          </div>
        </form>
      </ValidationObserver>
    </card>
  </div>
</template>

<script>

import {getResponse} from "@/util/utilities";
export default {
  name: "usuarioAddEdit",
  data(){
    return {
      roles: [],
      user: {
        idUsuario: 0,
        nombre: "",
        correo: "",
        alias: "",
        activo: true,
        externo: true,
        accesoDatos: 0,
        roles_idRol: null
      },
      telefono: "",
      idContacto: 0
    }
  },
  async mounted() {
    await this.getRoles();

    EventBus.$on("edit-user", (us) => {
      this.user = {
        idUsuario: us.idUsuario,
        nombre: us.nombre,
        correo: us.correo,
        alias: us.alias,
        activo: us.activo,
        externo: us.externo,
        accesoDatos: us.accesoDatos,
        roles_idRol: us.roles_idRol
      }
      this.telefono = us.contactoCliente?.telefono;
      this.idContacto = us.contactoCliente?.idContacto;
    });
  },
  methods: {
    async getRoles() {
      let payload = {
        id: 0,
        claveIdioma: "en",
        usuario: 0,
        onlyExternal: true
      };

      let request = await this.$http.put(route("Roles/getAllRoles"), payload);
      let response = getResponse(request, null);

      if(response != null){
        this.roles = response.rols;
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    async verifySave(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{
        if(!!!this.user.roles_idRol) throw new Error(this.$t('app.modules.users.errors.no_rol'));

        let response = null;
        if(this.user.idUsuario > 0){
          response = await this.edit();
        }
        else {
          response = await this.save();
        }

        if(response){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
          EventBus.$emit("update-list");
          this.cancel();
        }
        else this.notifyMessage("danger", this.$t("app.promps.error_user"));
      }
      catch (e){
        this.notifyMessage('danger', e.message);
      }
      finally
      {
        this.$swal.close();
      }
    },
    async save(){
      let payload = {
        Cliente_idClienteSAP: this.$store.state.user.idClienteSAP,
        Telefono: this.telefono,
        Usuario: this.user
      }

      let request = await this.$http.post(route("Usuarios/AddUserContactoCliente"), payload);
      return getResponse(request, null);
    },
    async edit(){
      let payload = {
        IdContacto: this.idContacto,
        Telefono: this.telefono,
        Usuario: this.user
      }
      let request = await this.$http.post(route("Usuarios/updateUserContactoCliente"), payload);
      if(request.body.code === 500){
        this.notifyMessage("danger", request.body.message);
        return null;
      }
      return getResponse(request, null);
    },
    cancel(){
      this.user = {
          idUsuario: 0,
          nombre: "",
          correo: "",
          alias: "",
          activo: true,
          externo: true,
          accesoDatos: 0,
          organizacion_idOrganizacion: 0,
          roles_idRol: null
      }
      this.telefono = "";
      this.idContacto = 0;
    }
  }
}
</script>

<style scoped>

</style>
